// 1. React and fabric. 
import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from '../Router5';
// 2. Store and Types. 
// 3. Scripts. 
// 4. Components and Views. 

interface IPlaceholderViewProps extends RouteComponentProps<any>
{
	MODULE_NAME?: string;
	SUB_TITLE?  : string;
	ID?         : string;
}

class PlaceholderView extends React.Component<IPlaceholderViewProps>
{
	constructor(props: IPlaceholderViewProps)
	{
		super(props);
		this.state =
		{
		}
	}

	public render() {
		const { MODULE_NAME, SUB_TITLE, ID } = this.props;
		return (
			<div>
				Placeholder
			</div>
		);
	}
}

export default withRouter(PlaceholderView);
